import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudToolsService} from '@shared/services/crud-tools.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService, IAlert} from '@shared/services/alert.service';
import {CrudUserService} from '@shared/services/crud-user.service';
import {CrudMarketsService} from '@shared/services/crud-markets.service';
import {CrudCompaniesService} from '@shared/services/crud-companies.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {ShareddataService} from '@shared/services/shareddata.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-users-tools-edit',
  templateUrl: './users-tools-edit.component.html',
  styleUrls: ['./users-tools-edit.component.scss']
})
export class UsersToolsEditComponent extends AbstractCrudEditComponent implements OnInit {

  clients: any[];
  roles: any[];
  toolKeyword: string;
  toolEnvName: string;
  usertoolid: string;

  marketGroups: {
    id: number,
    label: string,
    markets: number[]
  }[];

  iframeurl: string;

  private alertSelectedAosCompanyIds$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>('');
  private alertSelectedAosRoleIds$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>('');
  private alertSelectedAosAdditionalRightIds$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>('');
  private combinedAlert$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>('');

  constructor(
    private ref: ChangeDetectorRef,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected httpcrud: CrudUserService, // Specific
    protected httpmarketcrud: CrudMarketsService,
    protected httptoolscrud: CrudToolsService,
    protected httpcompanycrud: CrudCompaniesService,
    protected route: ActivatedRoute,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService,
    protected sharedData: ShareddataService,
    public sanitizer: DomSanitizer
  ) {
    super(activatedRoute, router, apifactory, httpcrud, alertService);

    this.fields = [];

    this.usertoolid = this.route.snapshot.paramMap.get('id');
    const userid = this.route.parent.snapshot.paramMap.get('id');
    this.entityrooturl = '/admin/users/' + userid + '/usertoolconfigs';

  }

  buildAlert() {
    // Alert management
    const message = [];
    if (this.alertSelectedAosCompanyIds$.getValue()) {
      message.push(this.alertSelectedAosCompanyIds$.getValue());
    }
    if (this.alertSelectedAosRoleIds$.getValue()) {
      message.push(this.alertSelectedAosRoleIds$.getValue());
    }
    if (this.alertSelectedAosAdditionalRightIds$.getValue()) {
      message.push(this.alertSelectedAosAdditionalRightIds$.getValue());
    }
    if (message) {
      this.combinedAlert$.next(`<div class="alert alert-warning" role="alert">` + message.join('<br/>') + `</div>`);
    }
  }

  getSafeUrl(url): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private setFields(markets, model) {
    // const fields: FormlyFieldConfig[]  = [
    //   {
    //     key: 'companyid',
    //     type: 'ng-select',
    //     props: {
    //       label: 'Company',
    //       closeOnSelect: true,
    //       clearable: true
    //     },
    //     hooks: {
    //       onInit: this.initCompanies
    //     }
    //   },
    //   {
    //     key: 'selectedusermarkets',
    //     type: 'ng-select2',
    //     props: {
    //       label: 'Markets',
    //       multiple: true,
    //       closeOnSelect: true,
    //       options: markets  // Markets are set at users-tool-main.component.ts
    //     },
    //   }
    // ];

    const fields: FormlyFieldConfig[] = [];
    this.fields = fields;

    // Add condition for aos tool
    if (model.classname === 'aos') { // or model.toolgroupflagkey === 'aos'
      this.fields = [
        {
          key: 'alert_sync_api',
          template: `<div class="alert alert-warning" role="alert">The AOS api root for the tool is not set. Set the "Sync api root" field at the tool configuration.</div>`,
          expressions: {
            hide: 'model.apiaosroot!=""'
          }
        },
        {
          key: 'alert_selected_aos_company_ids',
          type: 'custom-template',
          props: {
            htmlAsync: this.combinedAlert$,
          },
        },
        {
          key: 'selected_aos_company_ids',
          className: 'flex-1 form-control-sm',
          type: 'ng-select2',
          props: {
            label: 'AOS company',
            required: true,
            multiple: true,
          },
          hooks: {
            onInit: this.initAOSToolCompanies
          }
        },
        {
          key: 'selected_aos_role_ids',
          className: 'flex-1 form-control-sm',
          type: 'ng-select2',
          props: {
            label: 'AOS roles',
            required: true,
            multiple: true,
          },
          hooks: {
            onInit: this.initAOSToolRoles
          }
        },
        {
          key: 'selected_aos_additional_right_ids',
          className: 'flex-1 form-control-sm',
          type: 'ng-select2',
          props: {
            label: 'AOS additional rights',
            required: false,
            multiple: true,
          },
          hooks: {
            onInit: this.initAOSToolAdditionalRights
          }
        }
      ];
    } // if

    this.setReady();
  }

  initAOSToolCompanies = (field: any) => {
    if (!this.model.apiaosroot) {
      return;
    } // if
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getAOSCompanies(this.model.apiaosroot, this.model.username, this.model.mandant);

    query.subscribe({
      next: data => {
        typedField.props.options = data.results.aos_companies;

        // Set the value of the form after model initialization
        this.form.get('selected_aos_company_ids')?.setValue(data.results.selected_aos_company_ids);
      },
      error: err => {
        // const alertHtml = `<div class="alert alert-warning" role="alert">` + err.error.message + `</div>`;
        this.alertSelectedAosCompanyIds$.next(err.error.message);
        this.buildAlert();
      }
    });

  } // initAOSCompanies


  initAOSToolRoles = (field: any) => {
    if (!this.model.apiaosroot) {
      return;
    } // if
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getAOSToolRoles(this.model.apiaosroot, this.model.username, this.model.mandant);
    query.subscribe({
      next: data => {
        typedField.props.options = data.results.aos_roles;

        // Set the value of the form after model initialization
        this.form.get('selected_aos_role_ids')?.setValue(data.results.selected_aos_role_ids);
      },
      error: err => {
        this.alertSelectedAosRoleIds$.next(err.error.message);
        this.buildAlert();
      }
    });

  }

  initAOSToolAdditionalRights = (field: any) => {
    if (!this.model.apiaosroot) {
      return;
    } // if
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getAOSToolRights(this.model.apiaosroot, this.model.username, this.model.mandant);
    query.subscribe({
      next: data => {
        typedField.props.options = data.results.aos_additional_rights;

        // Set the value of the form after model initialization
        this.form.get('selected_aos_additional_right_ids')?.setValue(data.results.selected_aos_additional_right_ids);
      },
      error: err => {
        this.alertSelectedAosAdditionalRightIds$.next(err.error.message);
        this.buildAlert();
      }
    });
  }


  async getModelAndConfigureDynamicFields() {
    console.log('getModelAndConfigureDynamicFields');
    // this.entityid corresponds to the toolid
    const userid = this.route.parent.snapshot.paramMap.get('id');

    // tslint:disable-next-line:radix
    if (this.sharedData.getSelectedUser().id !== parseInt(userid)) {
      const {results} = await this.httpcrud.getEntity(userid).toPromise();
      this.sharedData.setSelectedUser(results);
    }

    const query = this.httpcrud.getUserToolConfig(userid, this.entityid);
    query.subscribe(async (data) => {

      this.toolKeyword = data.results.toolkeyword;
      const toolgroup = data.results.toolgroupflagkey;
      const toolMandantlabel = data.results.mandantflagkey;
      const toolEnvName = data.results.envnameflagkey;

      // Gets all currently configured markets for this user's tool
      const userName = this.sharedData.getSelectedUser().username;
      const mandantLabel = this.sharedData.getMandantLabel();
      const userToolMarkets = (await this.httpmarketcrud.getUserToolMarkets(
        userName, toolgroup, toolMandantlabel, toolEnvName).toPromise()
      ).results;

      const model: {} = {
        id: data.results.id,
        classname: toolgroup, // the classname:toolgroup here is the toolgroupflagkey value
        selectedusermarkets: userToolMarkets,
        userid,
        roles: data.results.roles,
        apiaosroot: data.results.apiaosroot,
        toolid: data.results.toolid,
        companyid: data.results.companyid === null ? 0 : data.results.companyid,
        aosmarkets: data.results.aosmarkets,
        aoscompanies: data.results.aoscompanies,
        username: userName,
        mandant: data.results.mandantlabel
      };

      // Gets all marketgroups for the current mandant
      this.marketGroups = this.sharedData.getMarketGroups();

      // Gets all available markets
      const markets = this.sharedData.getMarkets();

      this.setFields(markets, model);

      // Set model after
      this.model = model;

      // Refresh the form to set the selected markets.
      this.form.get('selectedusermarkets')?.setValue( this.model?.selectedusermarkets );


      this.sectionTitle = 'Edit tool ' + this.toolKeyword + (toolEnvName && toolEnvName !== 'prod' ? ' (' + toolEnvName + ')' : '');

    });
  }

  onSubmitHandler(): any {
    return () => {
      this.form.markAllAsTouched();
      if (this.form.valid) {
        this.isSubmitting = true;

        switch (this.model.classname) {
          case 'aos':
            const post$ = this.bffapi.setAOSUserTool(this.model.apiaosroot, this.model);
            post$.subscribe({
              next: results => {
                // Processing


                // Logging
                this.alertService.addAlert({
                  type: 'success',
                  title: 'Entity updated',
                  message: `The use tool information has been updated successfully with ` + this.model.apiaosroot,
                } as IAlert);

                this.isSubmitting = false;
              },
              error: err => {

                this.alertService.addAlert({
                  type: 'danger',
                  title: 'Error',
                  message: err.message,
                } as IAlert);
                this.isSubmitting = false;
              }
            });
            break;
          default:
            // update tool
            this.httpcrud.updateSpecificToolsConfigs(this.model).subscribe( () => {
              this.isSubmitting = false;
              this.alertService.addAlert({
                type: 'success',
                title: 'Entity updated',
                message: `The tool has been updated successfully`,
              } as IAlert);
            });
        }

      } else {
        // form not valid
        this.alertService.addAlert({
          type: 'danger',
          title: 'Error',
          message: `Incorrect inputs. Please review the form data.`,
        } as IAlert);
      }
    };
  }

  initAOSAppClients = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    if (!this.clients) {
      const query = this.bffapi.getAOSAppClients(this.usertoolid);
      query.subscribe((data) => {
        this.clients = data.results;
        typedField.templateOptions.options = this.clients;
      });
    } else {
      typedField.templateOptions.options = this.clients;
    }
  }

  initAOSRoles = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    if (!this.roles) {
      const query = this.bffapi.getAOSRoles(this.usertoolid);
      query.subscribe((data) => {
        this.roles = data.results;
        typedField.templateOptions.options = this.roles;
      });
    } else {
      typedField.templateOptions.options = this.roles;
    }
  }

  initActiveMarkets = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
  }

  /*
   * Form fields functions for dynamic values
   */
  initCompanies = (field: any) => {

    // Gets companies
    this.httpcompanycrud.getEntities().subscribe(({results}) => {

      this.sharedData.setCompanies(results);
      const typedField: Required<FormlyFieldConfig> = field;
      typedField.templateOptions.groupBy = (c) => c.groupLabel;
      typedField.templateOptions.options = [
        ...(this.toolKeyword.toLowerCase().indexOf('aos') !== -1 ? [] : [{label: 'None', id: 0}]),
        ...this.sharedData.getCompanies().map(
          c => {
            return {
              label: `${c.fullnr} ${c.label} (${c.variantlabel})`,
              groupLabel: c.label,
              id: c.id
            };
          }
        )];

      this.form.get('companyid')?.setValue( this.model.companyid );

    });
  }

  onClickMarketGroup(id: number) {
    const marketGroup = this.marketGroups.find(m => m.id === id);

    let newSelectedUserMarket = [];

    // if all ids of the market group are already selected
    const alreadySelected = this.model.selectedusermarkets.filter(selectedMarket => marketGroup.markets.indexOf(selectedMarket) !== -1);

    if (alreadySelected.length === marketGroup.markets.length) {
      // inverse selection
      newSelectedUserMarket = this.model.selectedusermarkets.filter(
        selectedMarket => marketGroup.markets.indexOf(selectedMarket) === -1
      );
    } else {
      // select missing market
      newSelectedUserMarket = this.model.selectedusermarkets;
      marketGroup.markets.forEach((marketId) => {
        if (alreadySelected.indexOf(marketId) === -1) {
          newSelectedUserMarket.push(marketId);
        }
      });
    }

    // patch form
    this.form.get('selectedusermarkets').patchValue(newSelectedUserMarket);
  }

}
